export default {
    NAME:'Document name',
    FILE:'Upload agreement',
    PLACEHOLDER_NAME:'Give this document a name',
    PLACEHOLDER_TYPE:'Select from the list',
    TYPE:'Document Type'
}